module.exports = "img/flags/BW.9338789.png";